import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render award categories section for FAQ Page
 */
const AwardCategoriesSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="award-categories-section-component"
    >
      <AccordionV2
        testId="award-categories"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="4. What are the Award categories?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p>They are:</p>

          <ul className="list-outside list-disc pl-8">
            <li>Emerging Enterprise Award</li>
            <li>Emerging Enterprise Sustainability Award</li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default AwardCategoriesSection;
